import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e077e9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-[436px] overflow-x-hidden overflow-y-scroll" }
const _hoisted_2 = { class: "px-[24px]" }
const _hoisted_3 = { class: "mt-[24px]" }
const _hoisted_4 = { class: "field-desc" }
const _hoisted_5 = { style: {"width":"328px"} }
const _hoisted_6 = {
  key: 0,
  class: "mt-[24px]"
}
const _hoisted_7 = { class: "field-desc" }
const _hoisted_8 = { style: {"width":"312px"} }
const _hoisted_9 = { class: "field-desc" }
const _hoisted_10 = { style: {"width":"302px"} }
const _hoisted_11 = { class: "mt-[24px]" }
const _hoisted_12 = { class: "field-desc" }
const _hoisted_13 = { class: "mt-[24px]" }
const _hoisted_14 = { class: "field-desc" }
const _hoisted_15 = { style: {"width":"344px"} }
const _hoisted_16 = { class: "mt-[24px]" }
const _hoisted_17 = { class: "field-desc" }
const _hoisted_18 = { style: {"width":"344px"} }
const _hoisted_19 = { class: "mt-[24px]" }
const _hoisted_20 = { class: "field-desc" }
const _hoisted_21 = { style: {"width":"220px"} }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-bottom-label mb-[6px]" }, "Optional, Default value if empty", -1))

import { IncrediField, IncrediForm, IncrediTooltip, useIncrediForm } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { computed, inject, onMounted, ref, watch } from 'vue';
import { IKActiveDirectory, IKActiveDirectoryManageGroups } from '@/components/common/dialogs/settingsActiveDirectoryDialog/activeDirectory.injection.keys';
import { Auth_Result_ErrorCode, External_Authentication_Type } from '@/graphql/codegen/generated/graphql';
import { isNumberInRange } from '@/services/utils';
import { formActions, protocolTypes } from '@/components/common/dialogs/settingsActiveDirectoryDialog/activeDirectoryConst';
import { useI18n } from 'vue-i18n';
import FormFooter from '@/components/common/dialogs/settingsActiveDirectoryDialog/formFooter.vue';
import IncrediToggle from '@/components/inputs/incrediToggle.vue';
import IncrediTextInput from '@/components/inputs/incrediTextInput.vue';
import { ResponseStatus } from '@/const/globals';


export default /*#__PURE__*/_defineComponent({
  __name: 'activeDirectoryForm',
  emits: ["onCloseDialog", "showError", "activateInProcess", "deactivateInProcess"],
  setup(__props, { emit }: { emit: ({ (e: 'onCloseDialog', value: formActions): void; (e: 'showError', value: Auth_Result_ErrorCode): void; (e: 'activateInProcess'): void; (e: 'deactivateInProcess'): void }), expose: any, slots: any, attrs: any }) {


const activeDirectoryAPI = inject(IKActiveDirectory);
const isActivateLoading = ref(false);
const manageSecurityGroupsHelpers = inject(IKActiveDirectoryManageGroups);

const { t } = useI18n();
const tooltipsModel = ref({
  ldap: false,
  ldapCertificate: false,
  bindDN: false,
  bindCredentials: false,
  searchBase: false,
  usernameAttribute: false,
  groupDN: false,
});

onMounted(() => {
  activeDirectoryAPI?.GQL_GetAD_Data?.refetch();
});

const isUserEnabled = computed(() => activeDirectoryAPI?.ldapAuthData?.value?.enabled || false);
const getProtocol = (value: string) => {
  const splitString = value?.split(':');
  return splitString.length > 0 ? splitString?.[0] : '';
};

const validateServer = (value: string, ldapEnabledValue: boolean = false) => {
  const splitString = value?.split(':');
  const host = splitString.length > 0 ? splitString?.[0] : 0;
  const port = splitString.length > 0 ? splitString?.[splitString.length - 1] : 0;
  if (!host) {
    return t('settings.dialogs.connectActiveDirectory.formValidations.required');
  }
  if ((host !== 'ldap' && ldapEnabledValue) || (host !== 'ldaps' && !ldapEnabledValue)) {
    return t('settings.dialogs.connectActiveDirectory.formValidations.invalid');
  }
  // means no : is provided
  if (splitString[0] === value || !port || !isNumberInRange(1, 65535, Number(port))) {
    return t('settings.dialogs.connectActiveDirectory.formValidations.range');
  }
  return true;
};

const { fields, form } = useIncrediForm({
  initialValues: {
    isLdapEnabled: activeDirectoryAPI?.ldapAuthData?.value?.url?.length ? getProtocol(activeDirectoryAPI?.ldapAuthData?.value?.url?.[0] || '') === protocolTypes.ldap : true,
    certificateAuthority: activeDirectoryAPI?.ldapAuthData?.value?.certificateAuthority?.[0] || '',
    ldapServer: activeDirectoryAPI?.ldapAuthData?.value?.url?.[0] || '',
    bindDN: activeDirectoryAPI?.ldapAuthData?.value?.bindDN || '',
    bindCredentials: '',
    groupSearchBase: activeDirectoryAPI?.ldapAuthData?.value?.groupSearchBase || '',
    searchBase: activeDirectoryAPI?.ldapAuthData?.value?.searchBase || '',
    usernameAttribute: activeDirectoryAPI?.ldapAuthData?.value?.usernameAttribute || '',
  },
  validationSchema: {
    ldapServer: (value: any) => validateServer(value, fields.isLdapEnabled.value.value),
    certificateAuthority: (value: any) => {
      if (!fields.isLdapEnabled.value.value) {
        return value?.length > 0 || t('settings.dialogs.connectActiveDirectory.formValidations.required');
      }
      return true;
    },
    bindDN: (value: any) => value?.length > 0 || t('settings.dialogs.connectActiveDirectory.formValidations.required'),
    bindCredentials: (value: any) => value?.length > 0 || t('settings.dialogs.connectActiveDirectory.formValidations.required'),
    searchBase: (value: any) => value?.length > 0 || t('settings.dialogs.connectActiveDirectory.formValidations.required'),
    groupSearchBase: (value: any) => value?.length > 0 || t('settings.dialogs.connectActiveDirectory.formValidations.required'),
  },
});

const submitForm = form.handleSubmit(async values => {
  const url = fields.ldapServer.value.value;
  const payload = {
    url,
    certificateAuthority: values.certificateAuthority,
    bindDN: values.bindDN,
    searchBase: values.searchBase,
    bindCredentials: values.bindCredentials,
    groupSearchBase: values.groupSearchBase,
    usernameAttribute: values.usernameAttribute,
  };
  isActivateLoading.value = true;
  emit('activateInProcess');
  const result: any = await activeDirectoryAPI?.activateAD(External_Authentication_Type.Ldap, payload);
  if (result?.data?.settings_externalAuth_ldap_update?.result?.status === ResponseStatus.Ok) {
    await activeDirectoryAPI?.GQL_GetAD_Data?.refetch();
    await manageSecurityGroupsHelpers?.GQL_Groups?.refetch();
    emit('onCloseDialog', formActions.activate);
  } else {
    emit('showError', result?.data?.settings_externalAuth_ldap_update?.result?.errorCode || Auth_Result_ErrorCode.GeneralError);
    if (result?.data?.settings_externalAuth_ldap_update?.result?.errorCode === Auth_Result_ErrorCode.CertificateValidationError) {
      form.setErrors({ certificateAuthority: t('settings.dialogs.connectActiveDirectory.formValidations.invalid') });
    }
  }
  isActivateLoading.value = false;
});

watch(
  () => activeDirectoryAPI?.ldapAuthData?.value,
  value => {
    fields.isLdapEnabled.value.value = getProtocol(value?.url?.[0] || '') === protocolTypes.ldap;
    fields.certificateAuthority.value.value = value?.certificateAuthority || '';
    fields.ldapServer.value.value = value?.url?.[0] || '';
    fields.bindDN.value.value = value?.bindDN || '';
    fields.searchBase.value.value = value?.searchBase || '';
    fields.groupSearchBase.value.value = value?.groupSearchBase || '';
    fields.usernameAttribute.value.value = value?.usernameAttribute || '';
  },
);

const handleDeactivate = async () => {
  emit('deactivateInProcess');
  await activeDirectoryAPI?.deactivateActiveDirectory(External_Authentication_Type.Ldap);
  await activeDirectoryAPI?.GQL_GetAD_Data?.refetch();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "relative" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createVNode(_unref(IncrediForm), {
            onSubmit: _withModifiers(_unref(submitForm), ["prevent"]),
            onKeydown: _cache[22] || (_cache[22] = _withKeys(($event: any) => ($event.preventDefault()), ["enter"]))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(IncrediToggle, {
                    modelValue: _unref(fields).isLdapEnabled.value.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(fields).isLdapEnabled.value.value) = $event)),
                    "default-toggle-value": _unref(fields).isLdapEnabled.value.value,
                    "toggle-on-text": "LDAP",
                    "toggle-off-text": "LDAPS",
                    disabled: _unref(isUserEnabled),
                    onInput: _cache[1] || (_cache[1] = 
                  () => {
                    _unref(fields).ldapServer.value.value = '';
                    _unref(form).setFieldError('ldapServer', '');
                    _unref(form).setFieldError('certificateAuthority', '');
                  }
                )
                  }, null, 8, ["modelValue", "default-toggle-value", "disabled"]),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.activeDirectory.ldap.text')), 1),
                      _createVNode(_unref(IncrediTooltip), {
                        modelValue: tooltipsModel.value.ldap,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tooltipsModel.value.ldap) = $event)),
                        direction: "top-middle",
                        "offset-x": 64,
                        width: "271px",
                        hover: ""
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.activeDirectory.ldap.tooltip')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("i", {
                            class: _normalizeClass([tooltipsModel.value.ldap ? 'uis uis-question-circle' : 'uil uil-question-circle', "question"])
                          }, null, 2)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createVNode(_unref(IncrediField), {
                      modelValue: _unref(fields).ldapServer.value.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(fields).ldapServer.value.value) = $event)),
                      name: "ldapServer",
                      size: "tiny",
                      label: _unref(fields).isLdapEnabled.value.value ? 'ldap://domain.subdomain:389' : 'ldaps://domain.subdomain:389',
                      error: !!_unref(form).errors.value.ldapServer,
                      "error-message": _unref(form).errors.value.ldapServer as any,
                      disabled: _unref(isUserEnabled),
                      onChange: _cache[4] || (_cache[4] = () => _unref(fields).ldapServer.validate())
                    }, null, 8, ["modelValue", "label", "error", "error-message", "disabled"])
                  ]),
                  (!_unref(fields).isLdapEnabled.value.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.activeDirectory.lpadAuthority.text')), 1),
                          _createVNode(_unref(IncrediTooltip), {
                            modelValue: tooltipsModel.value.ldapCertificate,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((tooltipsModel.value.ldapCertificate) = $event)),
                            direction: "top-middle",
                            "offset-x": 64,
                            width: "271px",
                            hover: ""
                          }, {
                            content: _withCtx(() => [
                              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.activeDirectory.lpadAuthority.tooltip')), 1)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("i", {
                                class: _normalizeClass([tooltipsModel.value.ldapCertificate ? 'uis uis-question-circle' : 'uil uil-question-circle', "question"])
                              }, null, 2)
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createVNode(IncrediTextInput, {
                          modelValue: _unref(fields).certificateAuthority.value.value,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(fields).certificateAuthority.value.value) = $event)),
                          "to-be-clearable": false,
                          name: "ldapServer",
                          type: "textarea",
                          maxlength: "30000",
                          class: "certificate-input",
                          outlined: "",
                          standout: "",
                          "input-class": "gordita-400-12",
                          error: !!_unref(form).errors.value.certificateAuthority,
                          "error-message": _unref(form).errors.value.certificateAuthority as any,
                          disabled: _unref(isUserEnabled),
                          onChange: _cache[7] || (_cache[7] = () => _unref(fields).certificateAuthority.validate())
                        }, null, 8, ["modelValue", "error", "error-message", "disabled"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(_unref(fields).isLdapEnabled.value.value ? 'mt-[24px]' : 'mt-[4px]')
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.activeDirectory.bindDN.text')), 1),
                      _createVNode(_unref(IncrediTooltip), {
                        modelValue: tooltipsModel.value.bindDN,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((tooltipsModel.value.bindDN) = $event)),
                        direction: "top-right",
                        hover: ""
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.activeDirectory.bindDN.tooltip')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("i", {
                            class: _normalizeClass([tooltipsModel.value.bindDN ? 'uis uis-question-circle' : 'uil uil-question-circle', "question"])
                          }, null, 2)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createVNode(_unref(IncrediField), {
                      modelValue: _unref(fields).bindDN.value.value,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(fields).bindDN.value.value) = $event)),
                      label: "CN=adminUser,CN=Users,DC=example,DC=local ",
                      name: "ldapServer",
                      size: "tiny",
                      disabled: _unref(isUserEnabled),
                      error: !!_unref(form).errors.value.bindDN,
                      "error-message": _unref(form).errors.value.bindDN as any,
                      onChange: _cache[10] || (_cache[10] = () => _unref(fields).bindDN.validate())
                    }, null, 8, ["modelValue", "disabled", "error", "error-message"])
                  ], 2),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.activeDirectory.bindCredentials.text')), 1),
                      _createVNode(_unref(IncrediTooltip), {
                        modelValue: tooltipsModel.value.bindCredentials,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((tooltipsModel.value.bindCredentials) = $event)),
                        direction: "top-right",
                        hover: ""
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.activeDirectory.bindCredentials.tooltip')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("i", {
                            class: _normalizeClass([tooltipsModel.value.bindCredentials ? 'uis uis-question-circle' : 'uil uil-question-circle', "question"])
                          }, null, 2)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createVNode(_unref(IncrediField), {
                      modelValue: _unref(fields).bindCredentials.value.value,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(fields).bindCredentials.value.value) = $event)),
                      name: "ldapServer",
                      size: "tiny",
                      "field-type": "password",
                      error: !!_unref(form).errors.value.bindCredentials,
                      "error-message": _unref(form).errors.value.bindCredentials as any,
                      onChange: _cache[13] || (_cache[13] = () => _unref(fields).bindCredentials.validate())
                    }, null, 8, ["modelValue", "error", "error-message"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.activeDirectory.groupDN.text')), 1),
                      _createVNode(_unref(IncrediTooltip), {
                        modelValue: tooltipsModel.value.groupDN,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((tooltipsModel.value.groupDN) = $event)),
                        direction: "top-right",
                        hover: ""
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.activeDirectory.groupDN.tooltip')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("i", {
                            class: _normalizeClass([tooltipsModel.value.groupDN ? 'uis uis-question-circle' : 'uil uil-question-circle', "question"])
                          }, null, 2)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createVNode(_unref(IncrediField), {
                      modelValue: _unref(fields).groupSearchBase.value.value,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(fields).groupSearchBase.value.value) = $event)),
                      label: "DC=example,DC=local",
                      name: "ldapServer",
                      size: "tiny",
                      "field-type": "text",
                      error: !!_unref(form).errors.value.groupSearchBase,
                      "error-message": _unref(form).errors.value.groupSearchBase as any,
                      onChange: _cache[16] || (_cache[16] = () => _unref(fields).groupSearchBase.validate())
                    }, null, 8, ["modelValue", "error", "error-message"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.activeDirectory.searchBase.text')), 1),
                      _createVNode(_unref(IncrediTooltip), {
                        modelValue: tooltipsModel.value.searchBase,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((tooltipsModel.value.searchBase) = $event)),
                        direction: "top-right",
                        "offset-x": -32,
                        hover: ""
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.activeDirectory.searchBase.tooltip')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("i", {
                            class: _normalizeClass([tooltipsModel.value.searchBase ? 'uis uis-question-circle' : 'uil uil-question-circle', "question"])
                          }, null, 2)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createVNode(_unref(IncrediField), {
                      modelValue: _unref(fields).searchBase.value.value,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(fields).searchBase.value.value) = $event)),
                      label: "CN=Users,DC=example,DC=local",
                      name: "ldapServer",
                      size: "tiny",
                      error: !!_unref(form).errors.value.searchBase,
                      "error-message": _unref(form).errors.value.searchBase as any,
                      onChange: _cache[19] || (_cache[19] = () => _unref(fields).searchBase.validate())
                    }, null, 8, ["modelValue", "error", "error-message"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.activeDirectory.usernameAttribute.text')), 1),
                      _createVNode(_unref(IncrediTooltip), {
                        modelValue: tooltipsModel.value.usernameAttribute,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((tooltipsModel.value.usernameAttribute) = $event)),
                        direction: "top-right",
                        hover: ""
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.activeDirectory.usernameAttribute.tooltip')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("i", {
                            class: _normalizeClass([tooltipsModel.value.usernameAttribute ? 'uis uis-question-circle' : 'uil uil-question-circle', "question"])
                          }, null, 2)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createVNode(_unref(IncrediField), {
                      modelValue: _unref(fields).usernameAttribute.value.value,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(fields).usernameAttribute.value.value) = $event)),
                      label: "sAMAccountName",
                      name: "ldapServer",
                      size: "tiny"
                    }, null, 8, ["modelValue"]),
                    _hoisted_22
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createVNode(FormFooter, {
                  "is-activate-loading": isActivateLoading.value,
                  "is-user-enabled": _unref(isUserEnabled),
                  onSubmitForm: _unref(submitForm),
                  onDeactivate: handleDeactivate
                }, null, 8, ["is-activate-loading", "is-user-enabled", "onSubmitForm"])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})